import React, { useEffect, useState } from 'react';
import { ProgressBar } from 'primereact/progressbar';
import "../../styles/pages/reviewsubmit.scss"
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { ReactComponent as FailIcon } from '../../assets/images/fail-icon.svg';
import { ReactComponent as PassIcon } from '../../assets/images/pass-icon.svg';
import { ReactComponent as SuccessUpload } from '../../assets/images/upload-success.svg';
import { ReactComponent as StopIcon } from '../../assets/images/stop-icon.svg';
import { ReactComponent as PauseIcon } from '../../assets/images/pause-icon.svg';
import AlertComponent from '../../components/Alert';

const Reviewsubmit = () => {
    const [value, setValue] = useState(0);
    const data = [
        { "sample": "Sample1B", "quality": "Pass", "upload_progress": 100 },
        { "sample": "Sample1D", "quality": "Fail", "upload_progress": 58 },
        { "sample": "Sample2A", "quality": "Pass", "upload_progress": 30 },
        { "sample": "Sample3B", "quality": "Fail", "upload_progress": 10 },
    ]

    const counter = () => {
        if (value < 100) {
            setValue(value + 10)
        }
    }

    useEffect(() => {
        const process = setInterval(counter, 2000)

        return () => {
            clearInterval(process)
        }
    }, [value])
    const sample = (val) => {
        return (
            val.quality === "Fail" ? <div style={{ color: "red" }}>{val.sample}</div> :
                <div>{val.sample}</div>
        )
    }

    const uploadProgress = (val) => {
        return (
            <div className='table_progress'>
                <ProgressBar value={val.upload_progress}></ProgressBar>
            </div>
        )
    }

    const quality = (val) => {
        return (
            val.quality === "Fail" ? <div style={{ color: "red" }}>
                <FailIcon />
                {val.quality}</div> :
                val.quality === "Pass" ? <div style={{ color: "green" }}>
                    <PassIcon />&nbsp;
                    {val.quality}</div> : <></>
        )
    }
    const progressValue = () => {
        if (value === 100) {
            return (
                <SuccessUpload />
            )
        }
    }
    const errorFunc = () => {
        let samples = []
        data.map((ele) => {
            if (ele.quality === "Fail") {
                samples.push(ele.sample + " failed quality check")
            }
        })
        return (
            samples.length !== 0 && (
                <div style={{ marginTop: "27px" }}>
                    <AlertComponent errors={samples} />
                </div>
            )

        )
    }
    return (
        <>
            <div className='row'>
                <div className='col'>
                    <h5>Step 3 - Review & Submit</h5>
                </div>
            </div>
            <div className='row justify-content-center'>
                <div className='col-8'>
                    <div style={{ position: "relative" }}>
                        <div>
                            <div className='progress_bar'>
                                <div style={{ display: "flex" }}>
                                    <ProgressBar value={value === 100 ? 15 : value} showValue={value === 100 ? true : false} displayValueTemplate={progressValue} className={value === 100 ? "upload_success" : "upload_bar"}></ProgressBar>
                                    {value !== 100 ? <div style={{ display: "flex", marginTop: "23px", marginLeft: "35px" }}>
                                        <Button label="Stop" icon={<StopIcon />} outlined />
                                        <Button label="Pause" icon={<PauseIcon />} outlined style={{ marginLeft: "23px" }} />
                                    </div> : <></>}
                                </div>

                                {value !== 100 ? <>
                                    {value < 90 ?
                                        <div style={{ position: "absolute", top: "21px", left: `${value * 5.5}px`, transition: "left 1s ease-in-out", marginLeft: "5px" }}>
                                            <h6>Estimated Time</h6><h2>20 min</h2>
                                        </div> :
                                        <div style={{ position: "absolute", top: "21px", right: "254px" }}>
                                            <h6>Estimated Time</h6><h2>20min</h2>
                                        </div>}
                                </> :
                                    <div style={{ position: "absolute", top: "27px", left: "153px" }}>
                                        <h2>Upload is complete</h2>
                                    </div>}
                            </div>
                            {value === 100 ? <>{errorFunc()}</> : <></>}
                        </div>

                        <div className='card' style={{ marginTop: "65px" }}>
                            <DataTable value={data} tableStyle={{ minWidth: '30rem' }}>
                                <Column field='sample' header='Sample' body={sample}></Column>
                                <Column field='upload_progress' header='Upload Progress' body={uploadProgress}></Column>
                                <Column field='quality' header='Quality' body={quality}></Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Reviewsubmit